import { cn } from "@/lib/utils";

export type IoEmptyDensity = "compact" | "comfortable";

// Single wording + styling for every "this output carries nothing" slot across
// the run surfaces (node preview panel, run drawer, results) — a blank slot
// under a labelled output reads as a broken render, not as an empty value.
export function IoEmptyValue({
  label = "Empty",
  density = "compact",
  className,
}: {
  label?: string;
  density?: IoEmptyDensity;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "block italic text-muted-foreground",
        density === "compact" ? "text-[11px]" : "text-sm",
        className
      )}
    >
      {label}
    </span>
  );
}
